/* errorElement do router (ver app/routes.tsx). Substitui a tela de erro crua do
   React Router por uma versão amigável em PT-BR. O caso mais comum é chunk
   ausente após um deploy novo — lazyWithReload já tenta recarregar 1x sozinho;
   esta tela é o fallback pra quando o reload não resolveu (ou pra qualquer outro
   erro de rota). */
import { useRouteError } from "react-router-dom";

const CHUNK_ERROR =
  /dynamically imported module|Importing a module script failed|error loading dynamically imported module|Failed to fetch/i;

export function RouteError() {
  const error = useRouteError();
  const msg = error instanceof Error ? error.message : String(error ?? "");
  const isChunk = CHUNK_ERROR.test(msg);

  return (
    <div
      role="alert"
      style={{
        display: "grid",
        placeItems: "center",
        minHeight: "60vh",
        padding: 24,
        textAlign: "center",
      }}
    >
      <div style={{ maxWidth: 420 }}>
        <h1 style={{ marginBottom: 12 }}>
          {isChunk ? "Uma nova versão está disponível" : "Algo deu errado"}
        </h1>
        <p style={{ marginBottom: 24, color: "var(--ink-soft)" }}>
          {isChunk
            ? "Publicamos uma atualização do Lucraa+. Recarregue a página para continuar."
            : "Não foi possível carregar esta tela. Tente recarregar."}
        </p>
        <div style={{ display: "flex", gap: 12, justifyContent: "center", flexWrap: "wrap" }}>
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => window.location.reload()}
          >
            Recarregar
          </button>
          <a className="btn btn-ghost" href="/">
            Voltar ao início
          </a>
        </div>
      </div>
    </div>
  );
}
